const REQUEST_STATE = {
  INITIALIZING: 'INITIALIZING',
  NONE: 'NONE',
  LOADING: 'LOADING',
  SAVING: 'SAVING',
};

export default REQUEST_STATE;
